"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __restKey = key => typeof key === "symbol" ? key : key + "";
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
var __export = (target, all) => {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from)) if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
      get: () => from[key],
      enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
// If the importer is in node compatibility mode or this is not an ESM
// file that has been converted to a CommonJS file using a Babel-
// compatible transform (i.e. "__esModule" has not been set), then set
// "default" to the CommonJS "module.exports" for node compatibility.
isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
  value: mod,
  enumerable: true
}) : target, mod));
var __toCommonJS = mod => __copyProps(__defProp({}, "__esModule", {
  value: true
}), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = value => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = value => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = x => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  AlternativeUpload: () => AlternativeUpload
});
module.exports = __toCommonJS(src_exports);

// src/components/AlternativeUpload.tsx
var import_react2 = __toESM(require("react"));
var import_react_intl3 = require("react-intl");
var import_nanoid = require("nanoid");
var import_byte_size3 = __toESM(require("byte-size"));
var import_ui_library = require("@printdeal/ui-library");
var import_uploadConfig2 = __toESM(require("@printdeal/cimpress-upload/lib/uploadConfig"));

// node_modules/@printdeal/data-layer-manager/build/index.js
var __defProp2 = Object.defineProperty;
var __getOwnPropSymbols2 = Object.getOwnPropertySymbols;
var __hasOwnProp2 = Object.prototype.hasOwnProperty;
var __propIsEnum2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp2 = (obj, key, value) => key in obj ? __defProp2(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues2 = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp2.call(b, prop)) __defNormalProp2(a, prop, b[prop]);
  if (__getOwnPropSymbols2) for (var prop of __getOwnPropSymbols2(b)) {
    if (__propIsEnum2.call(b, prop)) __defNormalProp2(a, prop, b[prop]);
  }
  return a;
};
var addDataLayerEntry = (event, parameters) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(__spreadValues2({
    event
  }, parameters));
};

// src/utils/utils.ts
var import_byte_size = __toESM(require("byte-size"));
var calcProgress = (loaded, total) => ({
  percentage: loaded / total * 100,
  total: (0, import_byte_size.default)(total),
  loaded: (0, import_byte_size.default)(loaded)
});

// src/api/upload-api.ts
var import_cimpress_upload_api = __toESM(require("@printdeal/cimpress-upload/lib/gateway/cimpress-upload-api"));
var import_DownloadUrlBuilder = __toESM(require("@printdeal/cimpress-upload/lib/services/DownloadUrlBuilder"));

// src/api/configuration.ts
var configuration = {
  tenant: "printdeal-production-uploads",
  clients: {
    uploads: {
      originalUrlTemplate: "https://uploads.documents.cimpress.io/v1/uploads/{uploadId}/original?tenant={tenant}",
      printUrlTemplate: "https://uploads.documents.cimpress.io/v1/uploads/{uploadId}?tenant={tenant}",
      previewUrlTemplate: "https://uploads.documents.cimpress.io/v1/uploads/{uploadId}/preview?tenant={tenant}"
    }
  }
};

// src/api/upload-api.ts
var {
  clients,
  tenant
} = configuration;
var downloadUrlBuilder = new import_DownloadUrlBuilder.default({
  originalUrlTemplate: clients.uploads.originalUrlTemplate,
  previewUrlTemplate: clients.uploads.previewUrlTemplate,
  printUrlTemplate: clients.uploads.printUrlTemplate,
  tenant
});
var uploadApi = new import_cimpress_upload_api.default({});

// src/components/ValidationMessage.tsx
var import_react = __toESM(require("react"));
var import_uploadConfig = __toESM(require("@printdeal/cimpress-upload/lib/uploadConfig"));
var import_validation_exception = __toESM(require("@printdeal/cimpress-upload/lib/exceptions/validation-exception"));
var import_byte_size2 = __toESM(require("byte-size"));
var import_react_intl = require("react-intl");
var ValidationMessage = _ref => {
  let {
    title,
    message,
    accept
  } = _ref;
  const localisedMessage = (0, import_react.useMemo)(() => {
    switch (message) {
      case import_validation_exception.default.size_limit:
        return /* @__PURE__ */import_react.default.createElement(import_react_intl.FormattedMessage, {
          id: "upload.validations.warnings.fileSize",
          defaultMessage: "The size of the file is too big. Max size: {maxUploadSize}",
          values: {
            maxUploadSize: (0, import_byte_size2.default)(import_uploadConfig.default.maxUploadSize).toString()
          }
        });
      case import_validation_exception.default.filetype:
        return accept ? /* @__PURE__ */import_react.default.createElement(import_react_intl.FormattedMessage, {
          id: "upload.validations.warnings.acceptedfileSupported",
          defaultMessage: "This fileType is not supported. Supported type: {acceptedType}",
          values: {
            acceptedType: accept && ".".concat(accept.split("/")[1])
          }
        }) : /* @__PURE__ */import_react.default.createElement(import_react_intl.FormattedMessage, {
          id: "upload.validations.warnings.fileSupported",
          defaultMessage: "This fileType is not supported. Supported types: {imageTypes} {fileTypes}",
          values: {
            imageTypes: "".concat(Object.keys(import_uploadConfig.default.imageUploadTypes).join(", "), ","),
            fileTypes: Object.keys(import_uploadConfig.default.fileUploadTypes).join(", ")
          }
        });
      default:
        return /* @__PURE__ */import_react.default.createElement(import_react_intl.FormattedMessage, {
          id: "upload.validations.warnings.unknown",
          defaultMessage: "Unexpected validation error"
        });
    }
  }, [message, accept]);
  return /* @__PURE__ */import_react.default.createElement(import_react.default.Fragment, null, /* @__PURE__ */import_react.default.createElement(import_react_intl.FormattedMessage, {
    id: "upload.validations.validationMessage",
    defaultMessage: "Error uploading file with filename {title}:",
    values: {
      title
    }
  }), "\xA0", localisedMessage);
};
var ValidationMessage_default = ValidationMessage;

// src/translations.ts
var import_react_intl2 = require("react-intl");
var translations = (0, import_react_intl2.defineMessages)({
  singleUploadRequired: {
    id: "alternative.upload.one.file.upload.isRequired",
    defaultMessage: "Drag or select your file into the field below"
  },
  uploadRequired: {
    id: "alternative.upload.upload.isRequired",
    defaultMessage: "Drag or select your file(s) into the field below"
  },
  selectSingleFile: {
    id: "alternative.upload.one.file.upload.link",
    defaultMessage: "select your file"
  },
  selectFiles: {
    id: "alternative.upload.upload.link",
    defaultMessage: "select your file(s)"
  },
  dragAndDropSingleFile: {
    id: "alternative.upload.one.file.upload.dragAndDrop",
    defaultMessage: "Drag and drop your file or"
  },
  dragAndDropFiles: {
    id: "alternative.upload.upload.dragAndDrop",
    defaultMessage: "Drag and drop your file(-s) or"
  },
  delete: {
    id: "alternative.upload.delete.uploaded.file",
    defaultMessage: "Delete"
  }
});

// src/components/AlternativeUpload.tsx
var AlternativeUpload = _ref2 => {
  let {
    id,
    name,
    isRequired = false,
    maxFiles = void 0,
    onChange,
    className = "",
    dataLayerData = {},
    accept = void 0
  } = _ref2;
  const [uploads, setUploads] = (0, import_react2.useState)({});
  const [validationMessage, setValidationMessage] = (0, import_react2.useState)(void 0);
  const [hasReachedFileLimit, setHasReachedFileInput] = (0, import_react2.useState)(false);
  const [isLoading, setIsLoading] = (0, import_react2.useState)(false);
  const intl = (0, import_react_intl3.useIntl)();
  const isSingleUpload = maxFiles === 1;
  const requiredLabelMessageId = isSingleUpload ? translations.singleUploadRequired : translations.uploadRequired;
  const selectLabel = intl.formatMessage(isSingleUpload ? translations.selectSingleFile : translations.selectFiles);
  const dropLabel = intl.formatMessage(isSingleUpload ? translations.dragAndDropSingleFile : translations.dragAndDropFiles);
  const handleChange = (0, import_react2.useCallback)(newFiles => __async(void 0, null, function* () {
    const key = (0, import_nanoid.nanoid)();
    const fileSize = (0, import_byte_size3.default)(newFiles[0].size);
    const extendedFile = {
      uploadTitle: newFiles[0].name,
      fileType: newFiles[0].type,
      fileSize: "".concat(fileSize.value, " ").concat(fileSize.unit)
    };
    if (accept && !accept.includes(extendedFile.fileType)) {
      return setValidationMessage({
        title: extendedFile.uploadTitle,
        message: "not_supported_file",
        accept
      });
    }
    setValidationMessage(void 0);
    setUploads(__spreadProps(__spreadValues({}, uploads), {
      [key]: extendedFile
    }));
    try {
      setIsLoading(true);
      const {
        data: [upload]
      } = yield uploadApi.uploadFile(newFiles[0], _ref3 => {
        let {
          loaded,
          total
        } = _ref3;
        setUploads(__spreadProps(__spreadValues({}, uploads), {
          [key]: __spreadProps(__spreadValues({}, extendedFile), {
            progress: calcProgress(loaded, total)
          })
        }));
      });
      const uploadedFile = __spreadProps(__spreadValues({}, extendedFile), {
        id: upload.uploadId,
        urls: {
          originalUrl: downloadUrlBuilder.getOriginalUrl(upload.uploadId),
          printUrl: downloadUrlBuilder.getPrintUrl(upload.uploadId),
          previewUrl: import_uploadConfig2.default.imageTypes.includes(upload.originalFileContentType) ? downloadUrlBuilder.getPreviewUrl(upload.uploadId) : void 0
        },
        uploadTimestamp: new Date(upload.processingTimeEnd).toISOString(),
        progress: {
          percentage: 100
        }
      });
      if (import_uploadConfig2.default.imageTypes.includes(upload.originalFileContentType)) {
        uploadedFile.urls.previewUrl = downloadUrlBuilder.getPreviewUrl(upload.uploadId);
      }
      const newUploads = __spreadProps(__spreadValues({}, uploads), {
        [key]: uploadedFile
      });
      setUploads(newUploads);
      if (typeof maxFiles === "number" && Object.keys(newUploads).length >= maxFiles) {
        setHasReachedFileInput(true);
      }
      onChange(Object.values(newUploads));
      addDataLayerEntry("alternative_upload", __spreadValues({
        eventLabel: "add_new_upload"
      }, dataLayerData));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setValidationMessage({
        title: extendedFile.uploadTitle,
        message: error[0]
      });
      addDataLayerEntry("alternative_upload", __spreadValues({
        eventLabel: "error_occurs"
      }, dataLayerData));
      setUploads(uploads);
    }
    return null;
  }), [uploads, accept, dataLayerData, maxFiles, onChange]);
  const handleDelete = key => {
    const _a = uploads,
      {
        [key]: _
      } = _a,
      newUploads = __objRest(_a, [__restKey(key)]);
    setUploads(newUploads);
    if (typeof maxFiles === "number" && Object.keys(newUploads).length < maxFiles) {
      setHasReachedFileInput(false);
    }
    onChange(Object.values(newUploads));
    addDataLayerEntry("alternative_upload", __spreadValues({
      eventLabel: "delete_file_or_page"
    }, dataLayerData));
  };
  return /* @__PURE__ */import_react2.default.createElement("div", {
    className,
    "data-testid": "alternative-upload-component"
  }, !accept && (hasReachedFileLimit ? /* @__PURE__ */import_react2.default.createElement(import_ui_library.Alert, {
    variant: "warning",
    className: "pd-mb-3"
  }, /* @__PURE__ */import_react2.default.createElement(import_react_intl3.FormattedMessage, {
    id: "upload.uploadButton.maxFiles",
    defaultMessage: "You have reached the maximum number of files. If you need to upload more files, please remove one of the current files, zip all your files, and upload that zipfile instead."
  })) : maxFiles && /* @__PURE__ */import_react2.default.createElement(import_ui_library.Alert, {
    variant: "info",
    className: "pd-mb-4",
    "data-testid": "max-attacments-alert"
  }, /* @__PURE__ */import_react2.default.createElement(import_react_intl3.FormattedMessage, {
    id: "account.quotes.form.helptext.maxAttachments",
    defaultMessage: "Note : Max {maxFiles} files allowed. Please make zip file to upload more.",
    values: {
      maxFiles
    }
  }))), /* @__PURE__ */import_react2.default.createElement(import_ui_library.FileField, {
    id,
    name,
    label: isRequired ? intl.formatMessage(requiredLabelMessageId) : void 0,
    dropLabel,
    selectLabel,
    value: "",
    required: isRequired,
    onChange: handleChange,
    validation: validationMessage && "error",
    validationMessage: validationMessage && /* @__PURE__ */import_react2.default.createElement(ValidationMessage_default, __spreadValues({}, validationMessage)),
    disabled: hasReachedFileLimit || isLoading,
    accept
  }, Object.entries(uploads).length ? Object.entries(uploads).map(_ref4 => {
    let [key, upload] = _ref4;
    var _a, _b;
    return /* @__PURE__ */import_react2.default.createElement(import_ui_library.FileInput.File, {
      key,
      image: ((_a = upload.urls) == null ? void 0 : _a.previewUrl) ? /* @__PURE__ */import_react2.default.createElement("img", {
        src: upload.urls.previewUrl,
        alt: upload.uploadTitle
      }) : /* @__PURE__ */import_react2.default.createElement(import_ui_library.Icon, {
        icon: "image"
      }),
      isLoading: ((_b = upload.progress) == null ? void 0 : _b.percentage) !== 100,
      name: upload.uploadTitle,
      size: upload.fileSize.toString(),
      type: upload.fileType,
      onDelete: () => handleDelete(key),
      deleteLabel: intl.formatMessage(translations.delete)
    });
  }) : null));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AlternativeUpload
});